import _ from 'lodash';
import { routeCreator } from '@adrias-online/steiner/lib/helpers';

import routeRegister from 'helpers/routeRegister';
import { selectors } from '../reducers/portaliCamere';
import { generateRoutes } from '../../../helpers/portaleModuleHelper';

const routes = generateRoutes('portaliCamere', selectors);

const list = _.values(routes.list).map((route) => ({
    ...route,
    requiredRoles: ['admin', 'developer', 'employee', 'amministrazione'],
    getComponent() {
        return new Promise((resolve) => {
            import(
                /* webpackChunkName: 'portaliCamere' */ `modules/portaliCamere/${route.componentPath}`
            ).then((response) => resolve(response.default));
        });
    },
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('portaliCamere', routes.patterns);
routeRegister.addLinks('portaliCamere', links);

export default list;
